/**
 * DevExtreme (esm/ui/list_light.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ListEdit from "./list/ui.list.edit.search";
import registerComponent from "../core/component_registrator";
registerComponent("dxList", ListEdit);
export default ListEdit;
